.activityMatchCustomFields {
  display: flex;
  flex-direction: column;
  row-gap: var(--spacingLg);
}
